import React, { createContext, useContext, useEffect, useState } from "react";
import { adminApi } from "../lib/ledgerApi";

const BrandingContext = createContext(null);

// Convert hex (#rrggbb) to HSL hsl-string used by tailwind CSS vars (e.g. "211 100% 50%")
function hexToHslTriplet(hex) {
  const m = hex.replace("#", "").match(/^([\da-f]{6})$/i);
  if (!m) return null;
  let r = parseInt(hex.substring(1, 3), 16) / 255;
  let g = parseInt(hex.substring(3, 5), 16) / 255;
  let b = parseInt(hex.substring(5, 7), 16) / 255;
  const max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  let h, s;
  const l = (max + min) / 2;
  if (max === min) {
    h = s = 0;
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      default: h = (r - g) / d + 4;
    }
    h /= 6;
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

const DEFAULT = {
  product_name: "NeoPay",
  brand_domain: "neopay",
  primary_color: "#3B82F6",
  logo_url: null,
  favicon_url: null,
  support_email: null,
};

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT);

  const apply = (b) => {
    const merged = { ...DEFAULT, ...(b || {}) };
    setBranding(merged);
    if (typeof document !== "undefined") {
      document.title = merged.product_name;
      const triplet = hexToHslTriplet(merged.primary_color);
      if (triplet) {
        document.documentElement.style.setProperty("--brand", triplet);
      }
      if (merged.favicon_url) {
        let link = document.querySelector("link[rel='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.head.appendChild(link);
        }
        link.href = merged.favicon_url;
      }
    }
  };

  const refresh = async () => {
    try {
      const b = await adminApi.getBranding();
      apply(b);
    } catch {
      apply(DEFAULT);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <BrandingContext.Provider value={{ branding, refresh, apply }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}
